import { Helper } from '../../common';
import { WidgetBase } from '../../widgets';

export class ModelHistoryWidget extends WidgetBase {
    baseType = 'ModelHistory';
    col = 0;
    configuration = {};
    guid: string;
    hasExtendedProperties = true;
    highlights = [];
    icon = '';
    name = 'ModelHistory';
    row = 0;
    sizeX = 12;
    sizeY = 2;
    type = 'ModelHistory';

    constructor(name: string) {
        super();
        this.guid = Helper.getGuid();
        if (name) {
            this.name = name;
        }
    }
}